export var findCouponTag = function findCouponTag(tags) {
  if (!tags) return null;
  return tags.find(function (tag) {
    return tag.type === 'coupon';
  });
};
export var findProductWithCoupon = function findProductWithCoupon(products) {
  if (!products) return null;
  return products.find(function (product) {
    var _product$seller;
    return findCouponTag((_product$seller = product.seller) == null ? void 0 : _product$seller.tags);
  });
};
export var formattedDate = function formattedDate(date) {
  if (!date) return null;
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short'
  });
};
export var getCouponInfo = function getCouponInfo(product) {
  var _findCouponTag = findCouponTag(product.seller.tags),
    code = _findCouponTag.code,
    discountType = _findCouponTag.discountType,
    discountValue = _findCouponTag.discountValue;
  return {
    code: code,
    discountType: discountType,
    discountValue: discountValue
  };
};
export var isValidDate = function isValidDate(date) {
  var parsedDate = new Date(date * 1000);
  return {
    isValid: !Number.isNaN(parsedDate.getTime()) && parsedDate >= new Date(),
    parsedDate: parsedDate
  };
};